// extracted by mini-css-extract-plugin
module.exports = {"expandGraphics":"expandGraphics","expandOnHover":"expandOnHover"};